import styled from "styled-components";

import Icon from "../../../imagery/Icon";
import { iconSizeMapping } from "../../../imagery/Icon/Icon.styles";
import Box from "../../../layout/boxes/Box";
import {
	StyledCloseButtonProps,
	StyledContentContainerProps,
	StyledModalDialogContainerProps,
	StyledModalScrollContainerProps,
} from "../Modal.types";

export const StyledModalContainer = styled(Box)`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 999;
`;

export const StyledContentContainer = styled.div<StyledContentContainerProps>`
	box-sizing: border-box;
	position: relative;
	z-index: 1;
	opacity: 1;
	width: 785px;
	max-width: 785px;
	outline: none;

	${({ viewport, theme }) => {
		const isDesktop = viewport.greaterThan.lg;
		const isTablet = viewport.greaterThan.sm && viewport.lessThan.lg;
		const isMobile = viewport.lessThan.sm;
		const closeButtonSize = iconSizeMapping.md;

		const style = {
			backgroundColor: theme.palette.hexForRole("bg_white"),
			border: `${theme.borderWidths.sm} solid ${theme.palette.hexForMandatory(
				"primary_1_200"
			)}`,
			...(isDesktop && {
				padding: `${theme.space.xxxl} 96px`,
				borderRadius: theme.radii.xxxl,
			}),
			...(isTablet && {
				padding: `${theme.space.xxl} ${theme.space.xxl} ${theme.space.xxxl} ${theme.space.xxl}`,
				borderRadius: theme.radii.xxl,
				width: "100%",
			}),

			...(isMobile && {
				paddingTop: `calc(${closeButtonSize} + ${theme.space.xxl})`,
				paddingBottom: theme.space.xl,
				borderRadius: theme.radii.xxl,
				minWidth: "100%",
				borderBottomLeftRadius: 0,
				borderBottomRightRadius: 0,
				width: "100%",
			}),
		};
		return style;
	}}
`;

export const StyledCloseButton = styled(Icon)<StyledCloseButtonProps>`
	cursor: pointer;
	position: absolute;
	margin: 0;
	padding: 0;
	background-color: transparent;
	border: none;
	z-index: 1;
	${({ viewport, theme }) => {
		const isDesktop = viewport.greaterThan.lg;
		const isTablet = viewport.greaterThan.sm && viewport.lessThan.lg;
		const isMobile = viewport.lessThan.sm;
		const pageSectionTheme = theme.components.pageSection;
		const pageSectionMargin = pageSectionTheme.margins[viewport.currentSize];

		return {
			...(isDesktop && {
				top: theme.space.xxxl,
				right: theme.space["xxxl-2"],
			}),
			...(isTablet && {
				top: theme.space.xxl,
				right: theme.space.xxl,
			}),
			...(isMobile && {
				top: theme.space.xxl,
				right: pageSectionMargin,
			}),
		};
	}}
`;

export const StyledOverlay = styled(Box)`
	${({ theme }) => ({
		backgroundColor: theme.palette.hexForRole("fg_dark_3"),
		opacity: 0.5,
	})}
`;

export const StyledModalScrollContainer = styled.div<StyledModalScrollContainerProps>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding: ${({ theme, viewport }) =>
		viewport.lessThan.sm ? 0 : theme.space.lg};
	overflow-y: auto;
	overflow-x: hidden;
`;

export const StyledModalDialogContainer = styled.div<StyledModalDialogContainerProps>`
	position: relative;
	display: flex;
	align-items: ${({ viewport }) =>
		viewport.lessThan.sm ? "flex-end" : "center"};
	justify-content: center;
	width: 100%;
	min-height: 100%;
`;
